module.exports = __webpack_public_path__ + "static/media/market.3c54c6e7.svg";